import { render, staticRenderFns } from "./orderItemCustomFieldPopover.vue?vue&type=template&id=1ce7d9d5&"
import script from "./orderItemCustomFieldPopover.vue?vue&type=script&lang=js&"
export * from "./orderItemCustomFieldPopover.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports